import type { DeepString } from "@/lib/i18n";

/**
 * CNestedCatalogs - polskie tłumaczenia (siatka katalogów potomnych).
 */
export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyList: "Brak informacji w tej sekcji.",
} as const;

export type CNestedCatalogsTranslations = DeepString<typeof pl>;
